<template>
  <div class="home">
    <b-container class="h=100">
      <b-row class="justify-content-center align-items-center h-100">
        <b-col cols="10" md="8" xl="6" class="my-5">
          <b-card :title="getGreeting()"
                  border-variant="primary"
                  class="shadow"
                 >
            <p>
              You've found the front page for AEID: the user account system for
              the free Australian Earthing Apps.
            </p>

            <p>
              There's not much to see here, you should look at the apps instead:
              <app-list />
            </p>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AppList from '@/components/AppList.vue'

export default {
  name: 'home',
  components: {
    AppList
  },
  data () {
    return {
      // NOTE: we're biasing the sampling by repeating elements
      greetings: [
        'G\'day!',
        'G\'day!',
        'Hi There!',
        'Hi There!',
        'Well, Hello!',
        'Hello, Possums!',
        'Hi!',
        'Hi!',
        'Welcome!',
        'Welcome!',
        'Greetings!'
      ]
    }
  },
  methods: {
    getGreeting () {
      var numGreetings = this.greetings.length
      var idx = Math.floor(Math.random() * numGreetings)
      return this.greetings[idx]
    }
  }
}
</script>
